export default {
  /* token */
  token: state => state.user.token,
  /* 用户信息 */
  userInfo: state => state.user.info
};
